export const FORM_PHONE_PREFIX = '+371';
